import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError, map } from 'rxjs/operators';
import { Client } from 'src/app/_models/models';
import { CommonService } from '../common.service';

@Injectable({
  providedIn: 'root'
})
export class ClientMasterService {

  httpClient: HttpClient;
  constructor(private common: CommonService, private client: HttpClient) { }

  
  getAll(name: string): Observable<any> {
   //debugger;
    let url = this.common.getApiAddress();

    if (name == undefined || name == null) {
      url = url + "/clientsmaster"
    } else {
      url = url + "/clientsmaster?name=" + name;
    }
    return this.client.get(url);
  }

  create(data: Client): Observable<Client> {
   //debugger;
    return this.client.post<Client>(this.common.getApiAddress() + "/clientsmaster", data)
      .pipe(
        map<Client, Client>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create client failed", e);
        })
      );
  }

  update(data: Client): Observable<Client> {
   //debugger;
    return this.client.put<Client>(this.common.getApiAddress() + "/clientsmaster/" + data.id.toString(), data)
      .pipe(
        map<Client, Client>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create client failed", e);
        })
      );
  }

  delete(id:number): Observable<Client> {
   //debugger;
    return this.client.delete<Client>(this.common.getApiAddress() + "/clientsmaster/" + id.toString())
      .pipe(
        map<Client, Client>(r => {
          return r;
        }),
        catchError(e => {
          return this.common.handleError("Create client failed", e);
        })
      );
  }
}
